module.exports = __webpack_public_path__ + "static/media/reckon2.abc5f083.PNG";